import { render, staticRenderFns } from "./ThreadAcceptTerms.vue?vue&type=template&id=61e40fe7"
import script from "./ThreadAcceptTerms.vue?vue&type=script&lang=js"
export * from "./ThreadAcceptTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports